"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var useStatusClass_1 = __importDefault(require("./useStatusClass"));
var types_1 = require("../../types");
var useStyles = styles_1.makeStyles({
    root: {
        border: 0,
        color: 'black',
        height: '100%',
        padding: 0,
        paddingLeft: '1%',
        width: '100%',
    },
});
var DocumentPageNumberInput = function (_a) {
    var onChange = _a.onChange, onFocus = _a.onFocus, onReachMaxLength = _a.onReachMaxLength, input = _a.input;
    var id = input.id, status = input.status, value = input.value;
    var isDisabled = status === types_1.PageInputStatus.Disabled;
    var classes = useStyles();
    var statusClass = useStatusClass_1.default(status);
    var handleChangedValue = function (value) {
        var _a;
        // Enforce numeric
        var isPotentiallyNumeric = value.match(/^(\d|\-|\.)*$/g);
        if (!isPotentiallyNumeric)
            return;
        // Enforce maxLength
        if (input.maxLength != null) {
            if (value.length === input.maxLength) {
                onReachMaxLength();
            }
            else if (value.length > input.maxLength) {
                value = (_a = input.value) !== null && _a !== void 0 ? _a : '';
            }
        }
        onChange(value);
    };
    var className = statusClass + " " + classes.root;
    return isDisabled ? (react_1.default.createElement("div", { className: className }, value !== null && value !== void 0 ? value : '')) : (
    // WORKAROUND Not using the native number input here because I cannot reliably
    // get rid of the spin buttons on every browser.
    // NOTE `inputMode="decimal"` makes the number pad display on iOS:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/inputmode
    react_1.default.createElement("input", { className: className, "data-tid": "DocumentPageNumberInput-input-" + id, inputMode: "decimal", onChange: function (e) { return handleChangedValue(e.target.value); }, onFocus: function () { return onFocus(); }, type: "text", value: value !== null && value !== void 0 ? value : '' }));
};
exports.default = DocumentPageNumberInput;
//# sourceMappingURL=DocumentPageNumberInput.js.map